"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// THIS FILE IS GENERATED BY OBJECTGEN TOOL. DO NOT EDIT BY HAND
// JsObjectsIndex.tt generates this file.
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(require("./HxObjectEnums"), exports);
__exportStar(require("./HxObjectType"), exports);
__exportStar(require("./HxPropertyID"), exports);
__exportStar(require("./HxRoot"), exports);
__exportStar(require("./HxError"), exports);
__exportStar(require("./HxPreferences"), exports);
__exportStar(require("./HxUnifiedMailbox"), exports);
__exportStar(require("./HxAccount"), exports);
__exportStar(require("./HxMailAccountData"), exports);
__exportStar(require("./HxCalendarAccountData"), exports);
__exportStar(require("./HxView"), exports);
__exportStar(require("./HxConversationHeader"), exports);
__exportStar(require("./HxSuggestion"), exports);
__exportStar(require("./HxPerson"), exports);
__exportStar(require("./HxMeetingRequest"), exports);
__exportStar(require("./HxMeetingResponse"), exports);
__exportStar(require("./HxMeetingCancellation"), exports);
__exportStar(require("./HxTimeZoneSystemEvent"), exports);
__exportStar(require("./HxCalendarRoot"), exports);
__exportStar(require("./HxWeatherData"), exports);
__exportStar(require("./HxPhotoData"), exports);
__exportStar(require("./HxCalendarGroupData"), exports);
__exportStar(require("./HxCalendarData"), exports);
__exportStar(require("./HxCategoryData"), exports);
__exportStar(require("./HxAppointmentHeader"), exports);
__exportStar(require("./HxAppointmentBody"), exports);
__exportStar(require("./HxMeetingAttendee"), exports);
__exportStar(require("./HxRightsManagementLicense"), exports);
__exportStar(require("./HxSmimeInformation"), exports);
__exportStar(require("./HxCalendarAttendeeCollectionPair"), exports);
__exportStar(require("./HxRmsTemplate"), exports);
__exportStar(require("./HxPhotoInfo"), exports);
__exportStar(require("./HxWeatherUpdates"), exports);
__exportStar(require("./HxCalendarCatalog"), exports);
__exportStar(require("./HxCalendarCatalogItem"), exports);
__exportStar(require("./HxGlobalApplicationSettings"), exports);
__exportStar(require("./HxTileNotification"), exports);
__exportStar(require("./HxNotificationData"), exports);
__exportStar(require("./HxMailToastData"), exports);
__exportStar(require("./HxCalendarNotificationData"), exports);
__exportStar(require("./HxHolidayCatalog"), exports);
__exportStar(require("./HxHolidayCatalogData"), exports);
__exportStar(require("./HxConversation"), exports);
__exportStar(require("./HxViewLink"), exports);
__exportStar(require("./HxRichContent"), exports);
__exportStar(require("./HxMessageHeader"), exports);
__exportStar(require("./HxMessageData"), exports);
__exportStar(require("./HxRecipient"), exports);
__exportStar(require("./HxContact"), exports);
__exportStar(require("./HxContactAddress"), exports);
__exportStar(require("./HxContactDate"), exports);
__exportStar(require("./HxContactPhone"), exports);
__exportStar(require("./HxContactSignificantOther"), exports);
__exportStar(require("./HxLocationEntityData"), exports);
__exportStar(require("./HxLocationSuggestionsData"), exports);
__exportStar(require("./HxContactAccountData"), exports);
__exportStar(require("./HxContactSyncState"), exports);
__exportStar(require("./HxContactSearchData"), exports);
__exportStar(require("./HxEasPolicies"), exports);
__exportStar(require("./HxContactUrl"), exports);
__exportStar(require("./HxMeetingRequestOccurrenceInfo"), exports);
__exportStar(require("./HxCatalogDataProvider"), exports);
__exportStar(require("./HxSharingMessageAction"), exports);
__exportStar(require("./HxOneRMContent"), exports);
__exportStar(require("./HxSuggestionLayoutData"), exports);
__exportStar(require("./HxSearchInstrumentationData"), exports);
__exportStar(require("./HxSharingPermissionsRequestsData"), exports);
__exportStar(require("./HxSharingPermissionInfoRequestsData"), exports);
__exportStar(require("./HxMailToastGroup"), exports);
__exportStar(require("./HxCalendarSharingDetailLevel"), exports);
__exportStar(require("./HxCalendarSharingPermission"), exports);
__exportStar(require("./HxInboxRule"), exports);
__exportStar(require("./HxRuleAction"), exports);
__exportStar(require("./HxRuleCondition"), exports);
__exportStar(require("./HxSearchResultAppointment"), exports);
__exportStar(require("./HxSearchResultAppointmentsBatch"), exports);
__exportStar(require("./HxLocalEvent"), exports);
__exportStar(require("./HxGlobalEasPolicies"), exports);
__exportStar(require("./HxFirstSync"), exports);
__exportStar(require("./HxRemappedServerId"), exports);
__exportStar(require("./HxClientExtensionNotificationMessage"), exports);
__exportStar(require("./HxClientExtensionNotification"), exports);
__exportStar(require("./HxContactImAddress"), exports);
__exportStar(require("./HxMeetingHeader"), exports);
__exportStar(require("./HxIconCatalog"), exports);
__exportStar(require("./HxIconData"), exports);
__exportStar(require("./HxFavoriteItem"), exports);
__exportStar(require("./HxAttachmentHeader"), exports);
__exportStar(require("./HxGroup"), exports);
__exportStar(require("./HxGroupDetail"), exports);
__exportStar(require("./HxGroupResource"), exports);
__exportStar(require("./HxGroupSettings"), exports);
__exportStar(require("./HxGroupDataClassification"), exports);
__exportStar(require("./HxGroupMember"), exports);
__exportStar(require("./HxTeachingCalloutDataCatalog"), exports);
__exportStar(require("./HxTeachingCalloutData"), exports);
__exportStar(require("./HxReminder"), exports);
__exportStar(require("./HxFavoritePerson"), exports);
__exportStar(require("./HxMention"), exports);
__exportStar(require("./HxMipLabelDisplayName"), exports);
__exportStar(require("./HxMipLabel"), exports);
__exportStar(require("./HxMipLabelTooltip"), exports);
__exportStar(require("./HxInboxRuleAddress"), exports);
__exportStar(require("./HxTailoredExperience"), exports);
__exportStar(require("./HxAttachmentSearchSession"), exports);
__exportStar(require("./HxAccountAttachmentSearchSession"), exports);
__exportStar(require("./HxAttachmentHeaderSearchData"), exports);
__exportStar(require("./HxSearchSession"), exports);
__exportStar(require("./HxMailSearchSession"), exports);
__exportStar(require("./HxAccountMailSearchSession"), exports);
__exportStar(require("./HxSuggestionSearchSession"), exports);
__exportStar(require("./HxAccountSuggestionSearchSession"), exports);
__exportStar(require("./HxMessageHeaderSearchData"), exports);
__exportStar(require("./HxCalendarSearchSession"), exports);
__exportStar(require("./HxAccountCalendarSearchSession"), exports);
__exportStar(require("./HxAppointmentHeaderSearchData"), exports);
__exportStar(require("./HxTimeSlotAvailabilityData"), exports);
__exportStar(require("./HxLocationTimeEntityData"), exports);
__exportStar(require("./HxContactEmailIndexEntry"), exports);
__exportStar(require("./HxRemoteMailbox"), exports);
__exportStar(require("./HxPresence"), exports);
__exportStar(require("./HxGroupMipLabel"), exports);
__exportStar(require("./HxBlockedSenderAndDomain"), exports);
__exportStar(require("./HxDelegateUser"), exports);
__exportStar(require("./HxInferredLocation"), exports);
__exportStar(require("./HxAddIn"), exports);
__exportStar(require("./HxPeopleSearchSession"), exports);
__exportStar(require("./HxAccountPeopleSearchSession"), exports);
__exportStar(require("./HxRecentlyUsedView"), exports);
__exportStar(require("./HxInitializationTriggerForLocalClassification"), exports);
__exportStar(require("./HxAnswerSearchSession"), exports);
__exportStar(require("./HxAccountAnswerSearchSession"), exports);
__exportStar(require("./HxTopSearchSession"), exports);
__exportStar(require("./HxStorageHealthStatistics"), exports);
__exportStar(require("./HxSpeedyMeetingSetting"), exports);
__exportStar(require("./HxToDoAccountData"), exports);
__exportStar(require("./HxToDoTask"), exports);
__exportStar(require("./HxAccountTopSearchSession"), exports);
__exportStar(require("./HxWidgetData"), exports);
__exportStar(require("./HxWidgetMessage"), exports);
__exportStar(require("./HxSearchableItem"), exports);
__exportStar(require("./HxContactCertificate"), exports);
__exportStar(require("./HxContactCategoryInfo"), exports);
__exportStar(require("./HxReactionType"), exports);
__exportStar(require("./HxReactionAuthor"), exports);
__exportStar(require("./HxReaction"), exports);
__exportStar(require("./HxRecipientSearchSession"), exports);
__exportStar(require("./HxAccountRecipientSearchSession"), exports);
__exportStar(require("./HxFileSearchSession"), exports);
__exportStar(require("./HxAccountFileSearchSession"), exports);
__exportStar(require("./HxFileHeader"), exports);
__exportStar(require("./HxFileHeaderSearchData"), exports);
__exportStar(require("./HxAadLogoData"), exports);
__exportStar(require("./HxPackageSizeStatistics"), exports);
__exportStar(require("./HxPreviewICSResult"), exports);
__exportStar(require("./HxLdapServerSetting"), exports);
__exportStar(require("./HxPreviewVCFResult"), exports);
__exportStar(require("./HxAccountContactSearchSession"), exports);
__exportStar(require("./HxUnifiedRecentlyUsedView"), exports);
__exportStar(require("./HxActivityFeedItem"), exports);
__exportStar(require("./HxMailSubscription"), exports);
__exportStar(require("./HxBestMatchSuggestion"), exports);
__exportStar(require("./HxOnlineArchiveMailbox"), exports);
__exportStar(require("./HxO365SubscriptionDetails"), exports);
__exportStar(require("./HxUserSettings"), exports);
__exportStar(require("./HxLocalEventsLocation"), exports);
__exportStar(require("./HxWeatherLocation"), exports);
__exportStar(require("./HxStringPair"), exports);
__exportStar(require("./HxTimeRange"), exports);
__exportStar(require("./HxUtcFloatableTimeRange"), exports);
__exportStar(require("./HxTimeSpan"), exports);
__exportStar(require("./HxRect"), exports);
__exportStar(require("./HxInt32Pair"), exports);
__exportStar(require("./HxObjectIdStringPair"), exports);
__exportStar(require("./HxObjectIdServerIdPair"), exports);
__exportStar(require("./HxDisplayPerson"), exports);
__exportStar(require("./HxAddInCustomProperties"), exports);
__exportStar(require("./HxGeoCoordinates"), exports);
__exportStar(require("./HxColor"), exports);
__exportStar(require("./HxTimeZoneRulePart"), exports);
__exportStar(require("./HxTimeZoneRule"), exports);
__exportStar(require("./HxDailyPattern"), exports);
__exportStar(require("./HxWeeklyPattern"), exports);
__exportStar(require("./HxMonthlyAbsolutePattern"), exports);
__exportStar(require("./HxMonthlyRelativePattern"), exports);
__exportStar(require("./HxYearlyAbsolutePattern"), exports);
__exportStar(require("./HxYearlyRelativePattern"), exports);
__exportStar(require("./HxNoEndPatternRange"), exports);
__exportStar(require("./HxEndDatePatternRange"), exports);
__exportStar(require("./HxNumberedPatternRange"), exports);
__exportStar(require("./HxAttendeeData"), exports);
__exportStar(require("./HxContactEmail"), exports);
__exportStar(require("./HxPauseSetting"), exports);
__exportStar(require("./HxDailySetting"), exports);
__exportStar(require("./HxExtractedKeyPhrase"), exports);
__exportStar(require("./HxMessageHeaderServerIdPair"), exports);
